<template>
  <v-container>
    <v-progress-linear
      v-if="!estimate || !$store.state.curPrice"
      indeterminate
      class="ma-2"
    ></v-progress-linear>
    <single-estimate 
      v-else 
      :key="componentId"
      :estimate="estimate"
      :price="$store.state.curPrice"
      :hideSiteBlock="true"
    ></single-estimate>
  </v-container>
</template>

<script>
import SingleEstimate from '../components/__import/estimates/SingleEstimate';

export default {
  props: {
    id: String
  },

  components: {
    SingleEstimate
  },

  data() {
    return {
      estimate: null,
      componentId: this.getTempId()
    }
  },

  created() {
    if (this.id) {
      this.$store.dispatch('loadSingleEstimate', this.id).then(res => {
        this.estimate = res;
        this.componentId = this.getTempId()
      });
      this.$store.dispatch('loadPrice');
      document.title = 'Карточка сметы';
    } 
  },

  watch: {
    id() {
      this.componentId = getTempId();
      if (this.id) {
        this.$store.dispatch('loadSingleEstimate', this.id).then(res => {
          this.estimate = res;
          this.componentId = this.getTempId()
        });
        this.$store.dispatch('loadPrice');
      } 
    }
  },

}
</script>